import React, { useEffect, useState } from 'react'
import dayjs from 'dayjs';
import { useDataActionExecutor } from '@agtech/core/data/actions/AgTechDataActions';
import AgTechTitleDetailHeader from '@agtech/web/components/Headers/AgTechTitleDetailHeader';
import { Sale, DefaultSale } from '@sales/data/sales/SaleData';
import { useSaleDataChangeSelectedSaleAction } from '@sales/data/sales/SaleDataActions';
import { SaleDataGetSalesQuery, SaleSelectionDTO } from '@sales/data/sales/SaleDataQueries';
import { useAgTechQuery } from '@agtech/core/data/queries/AgTechDataQueries';
import { useCurrentSale } from '@sales/data/sales/SaleDataStore';
import SaleDialog from '../../dialogs/SaleDialog';
import AgTechFormLookup from '@agtech/web/components/Forms/Controls/Lookups/AgTechFormLookup';
import AgTechHeaderDetail from '@agtech/web/components/Headers/AgTechHeaderDetail';

type SaleSelection = SaleSelectionDTO & {
    id: number
}

let SaleSelectionDropdown = (props: { classes?: string }) => {
    const actionExecutor = useDataActionExecutor();
    const saleChangeAction = useSaleDataChangeSelectedSaleAction();

    const currentSale = useCurrentSale();
    
    const saleSelectionQuery = useAgTechQuery({
        query: SaleDataGetSalesQuery,
        projection: data => data?.map(sale => ({
            ...sale,
            id: sale.saleId
        })) ?? []
    });

    let [selectedSale, setSelectedSale] = useState<Sale | null>(currentSale);

    let handleSaleChanged = async (sale: Sale | undefined) => {
        if (sale && sale.id !== selectedSale?.id) {
            const wasSaleAlreadySelected = selectedSale && selectedSale.id !== 0;

            setSelectedSale(sale);

            if (wasSaleAlreadySelected) {
                await actionExecutor.executeAction(saleChangeAction, {
                    submittedEntity: sale.id
                });
            }
        }

        return sale ?? DefaultSale;
    }

    useEffect(() => {
        if (currentSale) {
            handleSaleChanged(currentSale);
        }
    }, [currentSale?.id]);

    return currentSale ? (
        <AgTechFormLookup
            entityType={currentSale}
            control={{
                caption: 'Current Sale',
                isRequired: true,
                tabIndex: -1,
                showAsRequired: false,
                containerClasses: `wide ${props.classes ?? ''}`,
                containerStyles: { maxWidth: '100%' },
                controlClasses: 'rounded-light',
                inputClasses: 'non-bordered-f rounded-inherit',
                captionClasses: 'font-white-f mb-2'
            }}
            selection={{
                selectionControlTitle: 'Sales',
                popup: {
                    height: 240,
                    width: 360
                },
                data: {
                    itemQuery: saleSelectionQuery,
                    selectedItemId: selectedSale?.id.toString(),
                    searchItems: (sale, filter) => sale.saleName.includes(filter),
                },
                items: {
                    itemText: item => item.saleName,
                    itemRendering: e => (
                        <AgTechHeaderDetail
                            header={e.saleName}
                            detail={`${dayjs(e.saleStartDate).format("MM/DD/YYYY")}`}
                        />
                        // <AgTechTitleDetailHeader
                        //     title={e.saleName}
                        //     detail={`${dayjs(e.saleStartDate).format("MM/DD/YYYY")}}`}
                        //     titleFontSize='font-size-small'
                        //     detailFontSize='font-size-very-small'
                        //     detailClasses='mt-1-half'
                        // />
                    ),
                    itemHeight: 60,
                    itemCreationConfig: {
                        creationButtonText: 'Create new sale',
                        creationButtonAction: e => {
                            return new Promise<SaleSelection>((res, fail) => {
                                e.dialogs.openDialog({
                                    dialog: () => (
                                        <SaleDialog
                                            onSaleSubmitted={async createdSale => {
                                                res({
                                                    ...createdSale,
                                                    saleId: createdSale.id
                                                });
                                            }}
                                        />
                                    ),
                                });
                            });
                        },
                        noRecordsMessage: 'No sales were found in the system',
                        noRecordsPrompt: 'To create a sale, please click the button below'
                    }
                },
                behavior: {
                    onItemSelected: async (e, selectedSale) => {
                        return await handleSaleChanged(selectedSale);
                    },
                }
            }}
        />
    ) : null;
};

const useSaleSelectionDropdownQuery = () => {
    return 
}

export default SaleSelectionDropdown;